import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UI_SCALE_LEVELS, UiScaleService } from '../services/ui-scale.service';

@Component({
  selector: 'cygov-ui-scale-control',
  templateUrl: './ui-scale-control.component.html',
  styleUrls: ['./ui-scale-control.component.scss'],
  standalone: false,
})
export class UiScaleControlComponent implements OnInit, OnDestroy {
  readonly levels = UI_SCALE_LEVELS;
  effectiveScale = 1;
  maxScale = 1.25;
  private subs: Subscription[] = [];

  constructor(private uiScaleService: UiScaleService) {}

  ngOnInit(): void {
    this.subs.push(
      this.uiScaleService.effectiveScale$.subscribe(scale => (this.effectiveScale = scale)),
      this.uiScaleService.maxScale$.subscribe(max => (this.maxScale = max))
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  get preferredScale(): number {
    return this.uiScaleService.preferredScale;
  }

  /** The stored choice is above what this screen allows, so a smaller size is applied. */
  get isCapped(): boolean {
    return this.preferredScale > this.effectiveScale;
  }

  percent(scale: number): number {
    return Math.round(scale * 100);
  }

  labelFor(scale: number): string {
    return this.levels.find(level => level.scale === scale)?.label ?? `${this.percent(scale)}%`;
  }

  isAllowed(scale: number): boolean {
    return scale <= this.maxScale;
  }

  select(scale: number, event: Event): void {
    // keep the user menu open so sizes can be compared
    event.stopPropagation();
    if (this.isAllowed(scale)) {
      this.uiScaleService.setScale(scale);
    }
  }
}
